export const WEB_AWESOME_SYSTEM_FALLBACK_LIBRARY = 'webawesome-system-fallback'

const isFailedSystemIcon = (target: unknown): target is HTMLElement =>
  target instanceof HTMLElement &&
  target.tagName === 'WA-ICON' &&
  target.getAttribute('library') === 'system'

export const handleWebAwesomeIconError = (event: Event): void => {
  const source = event.composedPath()[0]

  if (isFailedSystemIcon(source)) {
    source.setAttribute('library', WEB_AWESOME_SYSTEM_FALLBACK_LIBRARY)
  }
}
